import { APP_INITIALIZER, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatIconModule } from '@angular/material/icon';

import { MatSortModule } from '@angular/material/sort';

import { MatTableModule } from '@angular/material/table';

import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';

import { MatTreeModule } from '@angular/material/tree';
import { MatMenuModule } from '@angular/material/menu';

import { MatExpansionModule } from '@angular/material/expansion';



import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { MatSelectModule } from '@angular/material/select';

import { CdkColumnDef } from '@angular/cdk/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { DatePipe } from '@angular/common';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { CommonModule } from "@angular/common";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { AccumulationChartModule, PieSeriesService, AccumulationDataLabelService, AccumulationLegendService, AccumulationTooltipService } from '@syncfusion/ej2-angular-charts';

// used to create fake backend
import { fakeBackendProvider } from './_helpers';

import { appRoutingModule } from './app.routing';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AppComponent } from './app.component';
import { HomeComponent } from './home';
import { RegisterComponent } from './register';
import { AlertComponent } from './_components';
import { CategoriesComponent } from "./categories";
import { SearchComponent } from './search/search.component';
import { FullTextSearchComponent } from './search/full-text/full-text.component';
import { SearchscreenComponent } from './searchscreen/searchscreen.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';

import { MatButtonModule } from '@angular/material/button';
import { MatSelectFilterModule } from 'mat-select-filter';
import {MatTooltipModule} from '@angular/material/tooltip';

//import { CategoryComponent} from "./category";;
import { MatListModule } from '@angular/material/list';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { LoaderComponent } from './loader/loader.component';
import { FiledetailsComponent } from './sidepanel/filedetails/filedetails.component';
import { FileViewComponent } from './sidepanel/fileView/fileView.component';
import { UploadComponent } from './upload/upload.component';;
import { DialogUploadfileComponent } from './categories/dialog-uploadfile/dialog-uploadfile.component';
import { ConfigHomeComponent } from './configuration/home/home.component';
import { CategoryConfigComponent } from './configuration/category-config/category-config.component';
import { SearchConfigComponent } from './configuration/search-config/search-config.component';
import { UsersAndGroupsComponent } from './configuration/users-and-groups/users-and-groups.component';
import { RecordsManagementComponent } from './configuration/records-management/records-management.component';
import { PolicyComponent, PolicyDialog } from './configuration/records-management/policy/policy.component';
import { RetentionComponent } from './configuration/records-management/retention/retention.component';
import { HoldsComponent } from './configuration/records-management/holds/holds.component';
import { PurgeListComponent } from './configuration/records-management/purge-list/purge-list.component';
import { UsersComponent } from './configuration/users-and-groups/users/users.component';
import { GroupsComponent } from './configuration/users-and-groups/groups/groups.component';
import { FileinboxComponent } from './fileinbox/fileinbox.component';
import { DndDirective } from './_directives/dnd.directive';
// import { TaskinboxComponent } from './taskinbox/taskinbox.component';
import { DialogUpdateCategoryComponent } from './sidepanel/dialog-update-category/dialog-update-category.component';
import { StringFilterPipe } from './_helpers/string-filter.pipe';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { DocumentRetentionComponent } from './sidepanel/document-retention/document-retention.component'
import { MyfilesComponent } from './fileinbox/myfiles/myfiles.component';
import { IndexpanelComponent } from './fileinbox/indexpanel/indexpanel.component';;
import { DocumentViewComponent } from './fileinbox/document-view/document-view.component';
import { ApplyHoldComponent } from './sidepanel/apply-hold/apply-hold.component';
import { DialogViewGroupsComponent } from './configuration/users-and-groups/dialog-view-groups/dialog-view-groups.component';
// import { TaskPanelComponent } from './taskinbox/task-panel/task-panel.component';
import { DisplaySearchDocComponent } from './search/display-search-doc/display-search-doc.component'
import { DialogRemoveHoldComponent } from './sidepanel/apply-hold/dialog-remove-hold/dialog-remove-hold.component';
import { UpdateDocumentTitleComponent } from './sidepanel/update-document-title/update-document-title.component';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { DialogDeleteConfirmComponent } from './dialog-delete-confirm/dialog-delete-confirm.component';
import { DialogCaptureUploadComponent } from './fileinbox/myfiles/dialog-capture-upload/dialog-capture-upload.component';



import { ImageViewerModule } from 'ng2-image-viewer';



import { BatchCategorizationComponent } from './fileinbox/batch-categorization/batch-categorization.component';
import { BulkOperationsComponent } from './configuration/bulk-operations/bulk-operations.component';
import { RulesConfigComponent } from './configuration/workflow-integrations/rules-config/rules-config.component';
import { WorkflowIntegrationsComponent } from './configuration/workflow-integrations/workflow-integrations.component';
import { ExternalConnConfigComponent } from './configuration/workflow-integrations/external-conn-config/external-conn-config.component';
import { BulkUpdateMetadataComponent } from './configuration/bulk-operations/bulk-update-metadata/bulk-update-metadata.component';
import { VirtualfolderComponent } from './mcrvirtualfolder/virtualfolder.component';
import { FileexplorerComponent } from './mcrvirtualfolder/fileexplorer/fileexplorer.component';
import { VirtualFoldersComponent } from './virtual-folders/virtual-folders.component';
import { VirtualFoldersConfigComponent } from './virtual-folders/virtual-folders-config/virtual-folders-config.component';
import { ApplicationVirtualFoldersComponent } from './virtual-folders/application-virtual-folders/application-virtual-folders.component';
import { ApplicationFileExplorerComponent } from './virtual-folders/application-virtual-folders/application-file-explorer/application-file-explorer.component'
import { GlacierComponent } from './glacier/glacier.component';
import { ExportComponent } from './status/export/export.component';
import { SsoLoginComponent } from './sso-login/sso-login.component';
// import { TaskListComponent } from './taskinbox/task-list/task-list.component';
import { FilePreviewComponent } from './categories/file-preview/file-preview.component';
// import { WorkflowHistoryComponent } from './taskinbox/task-panel/workflow-tasks/workflow-history.component';
import { DialogSaveSearchComponent } from "./search/dialog-save-search/dialog-save-search.component";
// import { RelatedDocumentsComponent } from './taskinbox/task-panel/related-documents/related-documents.component';
import { RedactKeywordsComponent } from './sidepanel/redact-keywords/redact-keywords.component';
import { QueueManagementComponent } from './configuration/queue-management/queue-management.component';
// import { ViewRelatedDocumentDialogComponent } from './taskinbox/view-related-document-dialog/view-related-document-dialog.component'
import { AppConfig } from 'src/assets/config/config/app-config';
import { RedactionManagementComponent } from './configuration/redaction-management/redaction-management.component';
import { RedactionMappingComponent } from './configuration/redaction-management/redaction-mapping/redaction-mapping.component';
import { RedactionProfilesComponent } from './configuration/redaction-management/redaction-profiles/redaction-profiles.component';
import { AdminConfigComponent } from './configuration/admin-config/admin-config.component';;
import { ShareDocumentLinkComponent } from './sidepanel/share-document-link/share-document-link.component'
import { SharedModuleModule } from './shared-module.module';
import { DialogUploadComponent } from './sidepanel/dialog-upload/dialog-upload.component';
import { InsightsComponent } from './insights/insights.component';

import { SAMLLoginComponent } from './saml-login/saml-login.component';

import { ManualRedactionComponent} from './sidepanel/manual-redaction/manual-redaction.component';



import { NgxFilesizeModule } from 'ngx-filesize';
import { QnaComponent } from './sidepanel/qna/qna.component';
import { DuplicateComponent } from './fileinbox/duplicates/duplicate.component';
import { FolderViewComponent } from './fileinbox/myfiles/folder-view/folder-view.component';
import { DialogFoldersConfigComponent } from './fileinbox/myfiles/folder-view/dialog-folders-config/dialog-folders-config.component';
import { IndexDocumentComponent } from './fileinbox/index-documents/index-document.component';
import { FileInboxDynamicForms } from './fileinbox/myfiles/dialog-capture-upload/fileinbox-dynamic-forms/fileinbox-dynamic-forms.component';
import { ReportComponent } from './fileinbox/reports/report.component';
import { TeamFilesComponent } from './fileinbox/teamfiles/teamfiles.component';
import { DialogTeamsDeleteConfigComponent } from './fileinbox/teamfiles/dialog-teams-delete-config/dialog-teams-delete-config.component';
import { LegacyIndexComponent } from './legacy-index/legacy-index.component';
import { DialogIndexMigrateComponent } from './fileinbox/index-documents/dialog-index-migrate/dialog-index-migrate.component';
import { CustomPaginatorIntl } from './_helpers/custom.paginator';
import { DialogPicklistComponent } from './configuration/category-config/dialog-picklist/dialog-picklist.component';
import { DeDuplicationComponent } from './de-duplication/de-duplication.component';
import { ConfirmDialogComponent } from './legacy-index/confirm-dialog/confirm-dialog.component';
import { BulkUpdateStatusComponent } from './status/bulk-update-status/bulk-update-status.component';

import { ViewMetadataComponent } from './sidepanel/view-metadata/view-metadata.component';
import { StatusComponent } from './status/status.component';

import { MatCommonModule } from '@angular/material/core';
import { PopUpComponent } from './common/pop-up/pop-up.component';

export function initConfig(config: AppConfig) {
    return () => config.load();
}

@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,

        MatIconModule,

        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,

        MatTableModule,        

        MatSortModule,
        MatPaginatorModule,
        MatSidenavModule,
        appRoutingModule,
        NgHttpLoaderModule.forRoot(),
        LayoutModule,
        MatToolbarModule,

        MatButtonModule,

        MatListModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatTabsModule,
        MatCardModule,

        MatTreeModule,

        NgtUniversalModule,

        MatMenuModule,

        MatExpansionModule,

        NgxFilesizeModule,

        NgMultiSelectDropDownModule.forRoot(),
        MatSlideToggleModule,

        MatSelectModule,

        MatDatepickerModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatNativeDateModule,

        NgxMatSelectSearchModule,

        QueryBuilderModule,
        CommonModule,
        NgJsonEditorModule,
        ImageViewerModule,
        DragDropModule,
        FlexLayoutModule,
        MatGridListModule,
        MatDividerModule,
        SharedModuleModule,

        AccumulationChartModule,
        NgxFilesizeModule,        
        MatSelectFilterModule,
        MatTooltipModule,

        MatCommonModule


    ],
    declarations: [
        AppComponent,
        HomeComponent,
        // LoginComponent,
        RegisterComponent,
        AlertComponent,
        CategoriesComponent,
        SearchComponent,
        FullTextSearchComponent,
        SearchscreenComponent,
        LoaderComponent,
        FiledetailsComponent,
        FileViewComponent,
        UploadComponent,
        DialogUploadfileComponent,
        CategoryConfigComponent,
        ConfigHomeComponent,
        SearchConfigComponent,
        RulesConfigComponent,
        ExternalConnConfigComponent,
        BulkOperationsComponent,
        BulkUpdateMetadataComponent,
        RecordsManagementComponent,
        UsersAndGroupsComponent,
        PolicyComponent,
        PolicyDialog,
        RetentionComponent,
        HoldsComponent,
        PurgeListComponent,
        UsersComponent,
        GroupsComponent,
        ApplyHoldComponent,
        DialogViewGroupsComponent,
        FileinboxComponent,
        DndDirective,
        // TaskinboxComponent,
        DialogUpdateCategoryComponent,
        DialogPicklistComponent,
        ConfirmDialogComponent,
        StringFilterPipe,
        DocumentRetentionComponent,
        MyfilesComponent,
        IndexpanelComponent,
        DocumentViewComponent,
        // TaskPanelComponent,
        DialogRemoveHoldComponent,
        DisplaySearchDocComponent,
        UpdateDocumentTitleComponent,
        DialogDeleteConfirmComponent,
        DialogCaptureUploadComponent,
        DialogIndexMigrateComponent,
        DialogTeamsDeleteConfigComponent,
        FolderViewComponent,
        DialogFoldersConfigComponent,
        

        BatchCategorizationComponent,
        WorkflowIntegrationsComponent,
        BulkUpdateMetadataComponent,
        VirtualFoldersComponent,
        VirtualFoldersConfigComponent,
        ApplicationFileExplorerComponent,
        ApplicationVirtualFoldersComponent,
        VirtualfolderComponent,
        FileexplorerComponent,
        VirtualFoldersComponent,
        GlacierComponent,
        ExportComponent,
        SsoLoginComponent,
        // TaskListComponent,
        FilePreviewComponent,
        // TaskListComponent,
        // WorkflowHistoryComponent,
        FilePreviewComponent,
        DialogSaveSearchComponent,
        // RelatedDocumentsComponent,
        RedactKeywordsComponent,
        QueueManagementComponent,
        // ViewRelatedDocumentDialogComponent,
        RedactionManagementComponent,
        RedactionMappingComponent,
        RedactionProfilesComponent ,
        AdminConfigComponent,
        ShareDocumentLinkComponent,
        InsightsComponent,
        SAMLLoginComponent,
        ManualRedactionComponent,
        QnaComponent,
        DuplicateComponent,
        IndexDocumentComponent,
        FileInboxDynamicForms,
        ReportComponent,
        TeamFilesComponent,
        LegacyIndexComponent,
        DeDuplicationComponent,
        BulkUpdateStatusComponent,
        ViewMetadataComponent,
        StatusComponent
    ],


    entryComponents:
        [
            
            LoaderComponent,
            DialogUploadComponent,
            PolicyDialog,
            DialogDeleteConfirmComponent,
            DialogViewGroupsComponent,
            DialogCaptureUploadComponent,
            DialogIndexMigrateComponent,
            DialogTeamsDeleteConfigComponent,
            CategoryConfigComponent,
            MyfilesComponent,
            DialogRemoveHoldComponent,
            DialogPicklistComponent,
            ConfirmDialogComponent,
            PopUpComponent             
        ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
        CdkColumnDef,
        DatePipe,
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [AppConfig],
            multi: true
        },
        PieSeriesService,
        AccumulationDataLabelService,
        AccumulationLegendService,
        AccumulationTooltipService
        // provider used to create fake backend
        //fakeBackendProvider
    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
})
export class AppModule { };